import type { InfoDoc } from '../infoContent';

/**
 * 利用規約。
 *
 * 法的効力に関わる文書のため、公開前に弁護士等の専門家による確認を推奨します。
 */
export const TERMS_DOC: InfoDoc = {
  title: '利用規約',
  sections: [
    {
      body: [
        '本利用規約（以下「本規約」といいます。）は、Ashiken AI Labs（以下「運営者」といいます。）が提供するチャットサービス「ChocoMesse」（以下「本サービス」といいます。）の利用条件を定めるものです。本サービスを利用するすべての方（以下「利用者」といいます。）は、本規約に同意したうえで本サービスを利用するものとします。',
      ],
    },
    {
      heading: '第1条（適用）',
      body: [
        '1. 本規約は、利用者と運営者との間の本サービスの利用に関する一切の関係に適用されます。',
        '2. 運営者が本サービス上で別途定めるルール・ガイドライン等は、本規約の一部を構成します。',
      ],
    },
    {
      heading: '第2条（定義）',
      body: [
        '本規約における用語の定義は次のとおりです。',
        '・「合言葉」とは、利用者が二者間のチャットルームに入室するために設定・入力する秘密の文字列をいいます。',
        '・「ニックネーム」とは、利用者が本サービス上で表示名として使用する名称をいいます。',
        '・「ルーム」とは、同一の合言葉により接続される、最大2名で構成されるチャット空間をいいます。',
        '・「アカウント」とは、利用者が任意に登録することで利用できる、ルーム管理用の登録情報をいいます。',
      ],
    },
    {
      heading: '第3条（利用登録）',
      body: [
        '1. 本サービスは、アカウント登録を行わなくても、合言葉とニックネームの入力のみで利用できます。',
        '2. 利用者は、ルームの管理等の追加機能を利用する場合に限り、運営者の定める方法によりアカウント登録を行うことができます。',
        '3. 運営者は、登録希望者に一定の事由があると判断した場合、登録を拒否し、又は登録後に取り消すことができます。',
      ],
    },
    {
      heading: '第4条（合言葉及びニックネームの管理）',
      body: [
        '1. 合言葉は、利用者自身の責任において管理するものとします。',
        '2. 合言葉が第三者に知られた場合、当該第三者がルームに入室し、会話内容を閲覧できる可能性があります。利用者は、合言葉を信頼できる相手にのみ共有するものとします。',
        '3. 合言葉の管理不十分、使用上の過誤、第三者の使用等によって生じた損害について、運営者は一切の責任を負いません。',
        '4. ルームには最大2名までしか入室できません。既に2名が入室しているルームへ入室することはできません。',
      ],
    },
    {
      heading: '第5条（禁止事項）',
      body: [
        '利用者は、本サービスの利用にあたり、次の各号に掲げる行為をしてはなりません。',
        '・法令又は公序良俗に違反する行為',
        '・犯罪行為に関連する行為',
        '・運営者、他の利用者又は第三者の権利・利益を侵害する行為',
        '・他の利用者に対する誹謗中傷、嫌がらせ、脅迫その他の迷惑行為',
        '・法令で送信が禁止される情報を発信する行為',
        '・本サービスのネットワーク又はシステムに過度の負荷をかける行為',
        '・本サービスの運営を妨害するおそれのある行為',
        '・不正アクセス、又はこれを試みる行為',
        '・他者の合言葉を不正に取得し、又は使用する行為',
        '・反社会的勢力に対して利益を供与する行為',
        '・その他、運営者が不適切と判断する行為',
      ],
    },
    {
      heading: '第6条（本サービスの提供の停止等）',
      body: [
        '1. 運営者は、次のいずれかに該当する場合、利用者に事前に通知することなく、本サービスの全部又は一部の提供を停止又は中断することができます。',
        '・システムの保守点検又は更新を行う場合',
        '・地震、停電、火災等の不可抗力により提供が困難となった場合',
        '・コンピュータ又は通信回線等が事故により停止した場合',
        '・その他、運営者が提供が困難と判断した場合',
        '2. 運営者は、提供の停止又は中断により利用者又は第三者が被った不利益・損害について、一切の責任を負いません。',
      ],
    },
    {
      heading: '第7条（利用制限及び登録抹消）',
      body: [
        '運営者は、利用者が本規約に違反した場合等には、事前の通知なく、当該利用者に対する本サービスの利用制限、又はアカウントの削除等の措置を講じることができます。',
      ],
    },
    {
      heading: '第8条（保証の否認及び免責事項）',
      body: [
        '1. 運営者は、本サービスに事実上又は法律上の瑕疵（安全性、信頼性、正確性、特定目的への適合性等を含みます。）がないことを明示的にも黙示的にも保証しません。',
        '2. 本サービスはメッセージ等のデータを保存しますが、運営者はその完全な保存・保全を保証するものではなく、データの消失等について責任を負いません。',
        '3. 運営者は、本サービスに起因して利用者に生じた損害について、運営者の故意又は重過失による場合を除き、一切の責任を負いません。',
      ],
    },
    {
      heading: '第9条（サービス内容の変更等）',
      body: [
        '運営者は、利用者への事前の通知なく、本サービスの内容を変更し、又は提供を終了することができ、これによって利用者に生じた損害について責任を負いません。',
      ],
    },
    {
      heading: '第10条（利用規約の変更）',
      body: [
        '運営者は、必要と判断した場合、利用者へ個別に通知することなく本規約を変更することができます。変更後の本規約は、本サービス上に表示した時点から効力を生じるものとします。',
      ],
    },
    {
      heading: '第11条（個人情報の取扱い）',
      body: [
        '運営者は、本サービスの利用によって取得した利用者の情報を、別途定める「プライバシーポリシー」に従って適切に取り扱います。',
      ],
    },
    {
      heading: '第12条（通知又は連絡）',
      body: [
        '利用者と運営者との間の通知又は連絡は、運営者の定める方法によって行うものとします。',
      ],
    },
    {
      heading: '第13条（権利義務の譲渡の禁止）',
      body: [
        '利用者は、運営者の書面による事前の承諾なく、本規約上の地位又は本規約に基づく権利義務を第三者に譲渡し、又は担保に供することはできません。',
      ],
    },
    {
      heading: '第14条（有料サービス）',
      body: [
        '1. 本サービスは現在ベータ版として無料で提供していますが、正式版リリース時に一部機能をプレミアム（有料）機能として提供する場合があります。',
        '2. 有料機能の内容、価格及び提供条件については、正式版リリース時に別途告知します。',
        '3. ベータ版提供中は、該当機能を引き続き無料でご利用いただけます。',
      ],
    },
    {
      heading: '第15条（準拠法・裁判管轄）',
      body: [
        '1. 本規約の解釈にあたっては、日本法を準拠法とします。',
        '2. 本サービスに関して紛争が生じた場合には、運営者の所在地を管轄する裁判所を専属的合意管轄裁判所とします。',
      ],
    },
    {
      body: [
        '制定日：2026年6月14日',
        '運営者：Ashiken AI Labs',
      ],
    },
  ],
};
